<script lang="ts">
	import { includeDeviceModal } from 'src/stores/features/inclusion';
	import { addDeviceModal } from 'src/stores/device-runtime/firmware-ui';

	import InclusionWizard from './Devices/DeviceWizard/IncludeWizard.svelte';
	import AssociateWizard from './Devices/DeviceWizard/AssociateWizard.svelte';
	import TemplatesModal from './Templates/TemplatesModal.svelte';
	import { isDeviceTemplatesSupported } from 'src/helpers/settings/settings_config_helpers';

	let showCloneSettingsModal = false;
	let newlyAddedDevice = null;
</script>

{#if $includeDeviceModal.show}
	<InclusionWizard />
{:else if $addDeviceModal}
	<AssociateWizard
		on:finished={(e) => {
			// newlyAddedDevice = e.detail.device;
			// showCloneSettingsModal = true;
		}}
	/>
{/if}

<!-- use this if you want to open TemplatesModal from inclusion process -->
<!-- {#if showCloneSettingsModal && newlyAddedDevice && isDeviceTemplatesSupported(newlyAddedDevice)}
	<TemplatesModal
		showModal={showCloneSettingsModal}
		device={newlyAddedDevice}
		mode="select"
		on:close={() => {
			newlyAddedDevice = null;
		}}
	/>
{/if} -->
